import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function Success() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('pending');

  useEffect(() => {
    if (!sessionId) {
      setStatus('invalid');
      setLoading(false);
      return;
    }
    const checkStatus = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/v1/payments/session-status`, { params: { session_id: sessionId } });
        if (res.data.payment_status === 'paid') {
          setStatus('paid');
        } else {
          setStatus('pending');
        }
      } catch (err) {
        setStatus('invalid');
      } finally {
        setLoading(false);
      }
    };
    checkStatus();
  }, [sessionId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status !== 'paid') {
    return (
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <Typography variant="h5" gutterBottom>
          Something went wrong
        </Typography>
        <Typography variant="body1" gutterBottom>
          We couldn’t confirm your payment. Please contact support.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/register')}>Try Again</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ textAlign: 'center', mt: 8 }}>
      <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
      <Typography variant="h4" gutterBottom>
        Payment Successful!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Welcome to Aven. Your account is now active.
      </Typography>
      <Button variant="contained" size="large" sx={{ mt: 2 }} onClick={() => navigate('/dashboard')}>
        Go to Dashboard
      </Button>
    </Box>
  );
}
